module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step_3_background-fc22d6816102cb4d7606b88585819aec.svg";